module.exports = __webpack_public_path__ + "static/media/criativos_feminino_ate_300.253ac9e2.jpg";